import { Injectable } from '@angular/core';

import { AnalyticsProvider } from '@shure/shared/angular/utils/analytics';
import { AnalyticsEvent } from '@shure/shared/models';

@Injectable()
export class AnalyticsProviderStub implements AnalyticsProvider {
	public optIn(): void {
		//
	}
	public optOut(): void {
		//
	}
	public trackEvent<T extends AnalyticsEvent>(_event: T): void {
		//
	}
}
